import { Body, Illumination, MoonPhase } from 'astronomy-engine'

export type MoonState = {
    /** Ecliptic phase angle in degrees: 0 new, 90 first quarter, 180 full, 270 last quarter. */
    phase: number
    /** Illuminated fraction of the disc, 0 to 1. */
    fraction: number
    name: string
    waxing: boolean
}

export const moonPhaseName = (phase: number): string => {
    if (phase < 7 || phase >= 353) return 'New moon'
    if (phase < 83) return 'Waxing crescent'
    if (phase < 97) return 'First quarter'
    if (phase < 173) return 'Waxing gibbous'
    if (phase < 187) return 'Full moon'
    if (phase < 263) return 'Waning gibbous'
    if (phase < 277) return 'Last quarter'

    return 'Waning crescent'
}

export const getMoonState = (date: Date): MoonState => {
    const phase = MoonPhase(date)
    const fraction = Illumination(Body.Moon, date).phase_fraction

    return {
        phase,
        fraction,
        name: moonPhaseName(phase),
        waxing: phase < 180
    }
}
